<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center">
      <div class="truncate">
        <h2 class="mb-25 font-weight-bolder">
          {{ toplam | toCurrency }} TL
        </h2>
        <span>{{ statisticTitle }}</span>
      </div>
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>

    </b-card-body>
    <b-card-footer class="d-flex justify-content-between text-body py-1">
      <div>
        <div>Sadakalar</div>
        <div>Zekatlar</div>
      </div>
      <div class="text-right font-weight-bolder">
        <div>{{ sadaka | toCurrency }} TL</div>
        <div>{{ zekat | toCurrency }} TL</div>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardFooter, BAvatar, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BCardFooter,
    BAvatar,
    BButton,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    zekat: {
      type: [Number, String],
      default: '0',
    },
    sadaka: {
      type: [Number, String],
      default: '0',
    },
    toplam: {
      type: [Number, String],
      default: '0',
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
